import { useEffect, useState } from "react";

export function formatTime(totalSeconds) {
  const s = Math.max(0, Math.ceil(totalSeconds));
  const m = Math.floor(s / 60);
  const ss = s % 60;
  return `${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}

// Supports both countdown (regressiva) and count-up (progressiva). Anchors to
// the absolute `startedAt` timestamp so remounting resumes at the correct value.
export function TimerText({ timer, style }) {
  const t = timer || { duration: 300, remaining: 300, running: false, startedAt: null, modo: "regressiva" };
  const base = t.remaining ?? t.duration ?? 0;
  const progressiva = t.modo === "progressiva";
  const compute = () => {
    const elapsed = t.running ? (Date.now() - (t.startedAt || Date.now())) / 1000 : 0;
    return progressiva ? base + elapsed : Math.max(0, base - elapsed);
  };
  const [display, setDisplay] = useState(compute());

  useEffect(() => {
    setDisplay(compute());
    if (!t.running) return;
    const id = setInterval(() => {
      const val = compute();
      setDisplay(val);
      if (!progressiva && val <= 0) clearInterval(id);
    }, 200);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t.running, base, t.startedAt, t.modo]);

  return <div style={style} data-testid="timer-text">{formatTime(display)}</div>;
}

// Current displayed value given a timer object (mode + absolute-clock aware).
export function currentRemaining(t) {
  if (!t) return 0;
  const base = t.remaining ?? t.duration ?? 0;
  if (t.running && t.startedAt) {
    const elapsed = (Date.now() - t.startedAt) / 1000;
    return t.modo === "progressiva" ? base + elapsed : Math.max(0, base - elapsed);
  }
  return base;
}
